import { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'universal-cookie';
import { jwtDecode } from 'jwt-decode';
import { validateCustomerActive } from "../services/api";

export const DataContext = createContext();

export function DataContextProvider(props) {
    const cookies = new Cookies();
    const [contextData, setContextData] = useState({ customer: {} });

    useEffect(() => {
        const token = cookies.get('token');
        const customerContext = cookies.get('customer_context');
        
        if (token) {
            try {
                const decoded = jwtDecode(token);
                let combinedCustomer = { ...decoded.customer };
                
                if (customerContext) {
                    const parsedContext = typeof customerContext === 'string' 
                        ? JSON.parse(customerContext) 
                        : customerContext;
                    
                    combinedCustomer = {
                        ...combinedCustomer,
                        ...parsedContext
                    };
                }
                
                setContextData({
                    ...decoded,
                    customer: combinedCustomer
                });
                
            } catch (error) {
                console.error('Error loading context:', error);
            }
        }
    }, []);

    const setToken = (token) => {
        try {
            const decoded = jwtDecode(token);
            cookies.set('token', token, { 
                path: '/',
                maxAge: 7 * 24 * 60 * 60
            });
            cookies.remove('customer_context', { path: '/' });
            setContextData(decoded);
        } catch (error) {
            console.error('Error setting token:', error);
        }
    };

    const setOrder = (orderId, accessCode, orderType) => {
        try {
            const customerContext = {
                order_id: orderId,
                access_code: accessCode,
                order_type: orderType,
                updated_at: new Date().toISOString()
            };
            
            cookies.set('customer_context', customerContext, { 
                path: '/',
                maxAge: 7 * 24 * 60 * 60
            });
            
            setContextData(prev => ({
                ...prev,
                customer: {
                    ...prev.customer,
                    ...customerContext
                }
            }));
            
            return true;
        } catch (error) {
            console.error('Error setting order:', error);
            return false;
        }
    };

    const checkCustomerAlive = async () => {
        const id = contextData.customer?.id;
        if (!id) return false;

        try {
            const result = await validateCustomerActive(id);
            return result.alive === true;
        } catch {
            return false;
        }
    };

    const logout = () => {
        cookies.remove('token', { path: '/' });
        cookies.remove('customer_context', { path: '/' });
        setContextData({ customer: {} });
    };

    const value = {
        contextData,
        setToken,
        setOrder,
        logout,
        checkCustomerAlive
    };

    return (
        <DataContext.Provider value={value}>
            {props.children}
        </DataContext.Provider>
    );
}

export function useDataContext() {
    const context = useContext(DataContext);
    if (!context) {
        throw new Error('useDataContext must be used within a DataContextProvider')
    }
    return context;
}